<template>
  <div>
    <div
      v-show="!isLoading"
      class="component-wrapper-loader"
    >
      <slot />
    </div>
    <transition
      v-if="isLoading"
      name="component-wrapper-loader-fade"
    >
      <div
        v-show="isLoading"
        :style="{ height: placeholderHeight, width: placeholderWidth }"
        class="component-wrapper-loader component-wrapper-loader--loader"
      />
    </transition>
  </div>
</template>

<script>


export default {
  name: 'ComponentWrapperLoader',
  props: {
    isLoading: { type: Boolean, default: false },
    placeholderHeight: { type: String, default: '100px' },
    placeholderWidth: { type: String, default: null },
  },
  methods: {
  },
};
</script>

<style lang="scss">


.component-wrapper-loader-fade-enter-active, .component-wrapper-loader-fade-leave-active {
  transition: opacity .5s;
  transition-delay: .2s;
}
.component-wrapper-loader-fade-enter-from, .component-wrapper-loader-fade-leave-to {
  opacity: 0;
}

.component-wrapper-loader {
  height: 100%;
  border-radius: 0.62rem;
  position: relative;


  &--loader{
    background: $white-lilac;
    background-repeat: no-repeat;
    width: 100%;
    overflow: hidden;
    &:after{
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, rgba(0, 0, 0, 0), rgba(#f5f5f5, 15%), rgba(0, 0, 0, 0));
      transform: translateX(-100%);
      animation: loading 1.8s infinite;
    }
  }

  @keyframes loading{
    100% {
      transform: translateX(100%);
    }
  }
}


</style>

